// extracted by mini-css-extract-plugin
export default {"managementMainContainer":"Management_managementMainContainer__f-YHn","campaignWrapper":"Management_campaignWrapper__gJQl5","filterTabs":"Management_filterTabs__hJAO8"};